import { Button, useNotify } from "react-admin";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  makeStyles,
} from "@material-ui/core";
import React, { useState } from "react";
import { StyledButton } from "../../../components/ListShowButton";
import { useField } from "react-final-form";
import { find, findIndex } from "lodash";
import { processRoutesToRemoveSchoolLocation } from "../tools";

const useStyles = makeStyles({
  dialog: {
    "& .MuiDialog-paper": {
      overflowY: "unset",
    },
  },
});

interface RemoveRouteButtonProps {
  routeName: string;
  mode: "create" | "update";
}

const RemoveRouteButton: React.FC<RemoveRouteButtonProps> = ({
  routeName,
  mode,
}) => {
  const [open, setOpen] = useState<boolean>(false);
  const [selectedRoute, setSelectedRoute] = useState<any>(null);

  const routesField = useField("routes");
  const droppedLocationsField = useField("droppedLocations");
  const busScheduleField = useField("busSchedule");
  const formRoutesChangedField = useField("formRoutesChanged");
  const oldRouteIdsField = useField("oldRouteIds");

  const classes = useStyles();
  const notify = useNotify();

  const handleOpenDialog = () => {
    const findRoute = find(routesField.input.value, ["routeName", routeName]);
    setSelectedRoute(findRoute);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSaveRemoveRoute = async () => {
    try {
      const findRouteIndex = findIndex(routesField.input.value, [
        "routeName",
        routeName,
      ]);

      if (mode === "create") {
        const processedRoutes = processRoutesToRemoveSchoolLocation(
          routesField.input.value,
          busScheduleField.input.value.type,
        );
        const lastIdOfDroppedLocations =
          droppedLocationsField.input.value.reduce(
            (prev: number, curr: any) => {
              return Math.max(prev, curr.id);
            },
            0,
          );
        const transformedLocations = processedRoutes[
          findRouteIndex
        ].routeLocations.map((loc: any, index: number) => {
          return {
            ...loc,
            id: lastIdOfDroppedLocations + index + 1,
            order: null,
            arrivalTime: null,
          };
        });

        droppedLocationsField.input.onChange([
          ...droppedLocationsField.input.value,
          ...transformedLocations,
        ]);

        formRoutesChangedField.input.onChange(true);
      }

      if (mode === "update" && selectedRoute.realRouteId !== 0) {
        oldRouteIdsField.input.onChange([
          ...oldRouteIdsField.input.value,
          selectedRoute.realRouteId,
        ]);
      }

      routesField.input.onChange([
        ...routesField.input.value.slice(0, findRouteIndex),
        ...routesField.input.value.slice(findRouteIndex + 1),
      ]);

      handleClose();
    } catch (error) {
      notify(error.message, "error");
    }
  };

  return (
    <>
      <StyledButton variant="outlined" onClick={handleOpenDialog}>
        Remove
      </StyledButton>

      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
        maxWidth="md"
      >
        <DialogTitle id="alert-dialog-title">
          Remove {selectedRoute?.routeName}
        </DialogTitle>
        <DialogContent>
          <DialogContentText color="initial">
            Are you sure you want to remove this route?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary" label="Back" />
          <Button
            onClick={handleSaveRemoveRoute}
            color="primary"
            label="Save"
          />
        </DialogActions>
      </Dialog>
    </>
  );
};

export default RemoveRouteButton;
